import router from '@/router/index';
import { modeIsEmulator } from '@/firebase/index';
import {
    onAuthStateChanged,
    getIdToken,
    signInWithPopup,
    GoogleAuthProvider,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendEmailVerification,
    signOut,
    sendPasswordResetEmail,
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { fireauth, firedb } from '@/firebase';

const provider = new GoogleAuthProvider();

export default {
    state: {
        user: null,
    },
    getters: {
        isAuthenticated() {
            return new Promise((resolve, reject) => {
                const unsubscribe = onAuthStateChanged(
                    fireauth,
                    (user) => {
                        unsubscribe();
                        resolve(user);
                    },
                    reject
                );
            });
        },
        idToken() {
            return new Promise((resolve, reject) => {
                const unsubscribe = onAuthStateChanged(
                    fireauth,
                    async (user) => {
                        if (user != null) {
                            const token = await getIdToken(user);
                            unsubscribe();
                            resolve(token);
                        }
                    },
                    reject
                );
            });
        },
        async apiKey() {
            const docRef = doc(firedb, 'config', 'apiKeys');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const apiKey = modeIsEmulator() ? 'emulator' : 'moosehead';
                return docSnap.data()[apiKey];
            } else {
                console.log('No apiKey document!');
                return null;
            }
        },
    },
    mutations: {
        logIn() {
            router.push('/login');
        },
        signIn(state, user) {
            state.user = user;
            router.push('/');
        },
        signOut(state) {
            state.user = null;
            state.userDoc = null;
            router.push('/login');
        },
    },
    actions: {
        async signUpWithEmailAndPassword({ commit }, { email, password }) {
            await createUserWithEmailAndPassword(fireauth, email, password)
                .then((response) => {
                    sendEmailVerification(response.user).then(() => {
                        commit('logIn');
                    });
                })
                .catch((error) => {
                    const errorMessages = ['auth/internal-error', 'auth/invalid-email', 'auth/email-already-in-use'];
                    if (errorMessages.includes(error.code)) {
                        throw Error('Invalid Email.');
                    } else {
                        throw error;
                    }
                });
        },
        async signInWithEmailAndPassword({ commit }, { email, password }) {
            await signInWithEmailAndPassword(fireauth, email, password)
                .then((response) => {
                    if (response.user.emailVerified) {
                        commit('signIn', response.user);
                    } else {
                        throw Error("Email isn't verified.");
                    }
                })
                .catch((error) => {
                    if (error.message === "Email isn't verified.") {
                        throw Error("Email isn't verified.");
                    }
                    throw Error('Invalid email or password.');
                });
        },
        async signInWithGoogle({ commit }) {
            signInWithPopup(fireauth, provider)
                .then((result) => {
                    commit('signIn', result.user);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async signOut({ commit, dispatch }) {
            await signOut(fireauth)
                .then(() => commit('signOut'))
                .then(() => dispatch('updateClient', null))
                .catch((error) => {
                    throw error;
                });
        },
        async resetPassword({ commit }, { email }) {
            await sendPasswordResetEmail(fireauth, email)
                .then(() => {
                    commit('logIn');
                })
                .catch((error) => {
                    throw error;
                });
        },
    },
};
